// extracted by mini-css-extract-plugin
export default {"table":"Turnaround_table__H93dP","totals":"Turnaround_totals__+gW2r","row":"Turnaround_row__7nxo-","control":"Turnaround_control__Qwk6r"};